export class DatiPersonaliDTO {
  datiComuni: boolean;

  datiParticolari: boolean;

  datiGiudiziari: boolean;

  datiRiservati: Boolean; // solo per fascicolo

  privato: boolean; //livello di consultabilità  (pubblico/privato)

  motivoRestrizioni: string;

  condizioniRiproduzione: string;

  condizioniConsultazione: string;
}
